import { set as setCookie, get as getCookie } from 'es-cookie';
import { CookieAttributes } from 'es-cookie/src/CookieAttributes';

import { PROD } from '@shared/config/env';
import BrowserUtils from '@zvuk-b2b/react-uikit/toolkit/BrowserUtils';
import CookieUtils, { CookieAttributes as CookieAttributesUtils } from '@zvuk-b2b/react-uikit/toolkit/CookieUtils';

export const PROMOCODE_COOKIE_NAME = 'promocode'; // TODO: move to local storage
export const SBER_AGENT_ID_COOKIE_NAME = 'sber_agent_id'; // TODO: move to local storage

export const getCookieByKey = (key: string): string | undefined => getCookie(key);

export const setCookieByKey = (key: string, value: string, params?: CookieAttributes): void => {
  const inIframe = BrowserUtils.inIframe();

  if (inIframe) {
    const attributes: CookieAttributesUtils = {
      ...params,
      sameSite: 'none',
      secure: true,
      partitioned: true,
    };

    CookieUtils.set(key, value, attributes);

    return;
  }

  const attributes: CookieAttributes = {
    ...params,
    sameSite: 'none',
    secure: true,
  };

  setCookie(key, value, PROD ? attributes : params);
};
